var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { id: "v-select" },
      on: {
        mousedown: (e) => {
          if (!_vm.disabled) _vm.handleOpenSelect(e)
        },
      },
    },
    [
      _c(
        "a-select",
        _vm._b(
          {
            directives: [{ name: "deselect", rawName: "v-deselect" }],
            ref: "vSelect",
            staticClass: "v-select-main",
            attrs: {
              allowClear: _vm.allowClear,
              value: _vm.hookValue,
              dropdownMatchSelectWidth: false,
              mode: _vm.mode,
              getPopupContainer: (triggerNode) => triggerNode.parentElement,
              "show-arrow": _vm.showSearch ? false : true,
              "show-search": true,
              "filter-option": false,
              "default-active-first-option": false,
              maxTagCount: _vm.maxTagCount,
              maxTagPlaceholder: _vm.maxTagPlaceholder,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              dropdownClassName: _vm.dropdownClassName,
            },
            on: {
              deselect: _vm.handleDeselect,
              mouseenter: function ($event) {
                return _vm.$emit("mouseenter")
              },
              search: (text) => _vm.filterOption(text),
            },
            scopedSlots: _vm._u([
              {
                key: "clearIcon",
                fn: function () {
                  return [
                    _c("a-icon", {
                      staticStyle: { "font-size": "14px" },
                      attrs: { type: "close-circle" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleClear.apply(null, arguments)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          "a-select",
          _vm.mode === "default" ? {} : { open: _vm.selectOpen },
          false
        ),
        [
          _c(
            "div",
            {
              staticStyle: { overflow: "auto" },
              attrs: { slot: "dropdownRender" },
              slot: "dropdownRender",
            },
            [
              _c(
                "a-spin",
                { attrs: { tip: "加载中...", spinning: _vm.optionsLoading } },
                [
                  _vm.options.length
                    ? _c(
                        "div",
                        [
                          _vm.mode === "multiple"
                            ? [
                                _c("a-input-search", {
                                  ref: "multipleInputSearch",
                                  staticClass: "select-search-wrap",
                                  attrs: { placeholder: "搜索" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    change: function ($event) {
                                      return _vm.filterOption(_vm.search)
                                    },
                                  },
                                  model: {
                                    value: _vm.search,
                                    callback: function ($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search",
                                  },
                                }),
                                _vm.isSelectAll
                                  ? _c(
                                      "a-checkbox",
                                      {
                                        staticClass: "check-item",
                                        attrs: {
                                          checked:
                                            _vm.selectValue.length ===
                                              _vm.constHookOptions.length &&
                                            _vm.selectValue.length > 0,
                                        },
                                        on: { change: _vm.selectAll },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [_vm._v("全选")]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _c(
                            "a-spin",
                            {
                              attrs: {
                                tip: "查询中...",
                                spinning: _vm.searchLoading,
                              },
                            },
                            [
                              _vm.hookOptions.length
                                ? _c("RecycleScroller", {
                                    staticStyle: {
                                      "min-height": "32px",
                                      overflow: "auto",
                                    },
                                    style: { maxHeight: _vm.maxHeight + "px" },
                                    attrs: {
                                      type: "default",
                                      items: _vm.hookOptions,
                                      "item-size": 32,
                                      buffer: 100,
                                      mode: _vm.mode,
                                      prop: {
                                        value: _vm.optionsFields.value,
                                        text: _vm.optionsFields.label,
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "check-item",
                                                  class: {
                                                    selected: _vm.valueKey
                                                      ? item[_vm.valueKey] ===
                                                        _vm.value
                                                      : _vm.value &&
                                                        item[
                                                          _vm.optionsFields
                                                            .value
                                                        ] ===
                                                          (_vm.value[
                                                            _vm.optionsFields
                                                              .value
                                                          ] || {}),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return ((e) =>
                                                        _vm.checkChange(
                                                          item
                                                        )).apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.mode === "multiple"
                                                    ? _c("span", {
                                                        staticClass:
                                                          "check-box-pointer",
                                                        class: {
                                                          checked: item.flag,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.labelSlots
                                                    ? _vm._t(
                                                        "label",
                                                        null,
                                                        null,
                                                        item
                                                      )
                                                    : _c("TextTooltip", {
                                                        attrs: {
                                                          placement: "topLeft",
                                                          text: item[
                                                            _vm.optionsFields
                                                              .label
                                                          ],
                                                        },
                                                      }),
                                                ],
                                                2
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }